// extracted by mini-css-extract-plugin
export default {"form":"Initial_form__CsdKj","texts":"Initial_texts__xvk5P"};